/**
 * Free Gift Toast — fires when customer adds a BxGy-qualifying product.
 * Non-intrusive: shows a small toast at bottom-right with link to /cart.
 * Full gift picker UX lives on /cart page (cart-gift-picker section).
 *
 * Reads window.FGP_TRIGGER_IDS — flat array of product IDs that qualify for any gift.
 */
(function () {
  if (window.__fgtInit) return;
  window.__fgtInit = true;

  const TRIGGER_IDS = Array.isArray(window.FGP_TRIGGER_IDS)
    ? window.FGP_TRIGGER_IDS
    : [];
  if (TRIGGER_IDS.length === 0) return;

  const toast = document.getElementById("fgt");
  const closeBtn = document.getElementById("fgt-close");
  if (!toast) return;

  // Don't show if user is already on /cart page
  const onCartPage = /\/cart(\/|$|\?)/.test(window.location.pathname);

  let hideTimer = null;

  function show() {
    if (onCartPage) return;
    toast.hidden = false;
    requestAnimationFrame(() => toast.classList.add("is-visible"));
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, 7000);
  }

  function hide() {
    toast.classList.remove("is-visible");
    setTimeout(() => {
      if (!toast.classList.contains("is-visible")) toast.hidden = true;
    }, 300);
  }

  closeBtn?.addEventListener("click", hide);

  function isTrigger(productId) {
    return TRIGGER_IDS.includes(productId);
  }

  function checkItems(items) {
    if (!Array.isArray(items)) items = [items];
    return items.some((it) => it && isTrigger(it.product_id));
  }

  // --- intercept fetch ---
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : input?.url || "";
    const isCartAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    const skip = window.__fgpAddingGifts === true;
    const promise = origFetch.apply(this, arguments);
    if (isCartAdd && !skip) {
      promise
        .then((res) => {
          if (!res || !res.ok) return;
          res
            .clone()
            .json()
            .then((data) => {
              const items = data.items || (Array.isArray(data) ? data : [data]);
              if (checkItems(items)) show();
            })
            .catch(() => {});
        })
        .catch(() => {});
    }
    return promise;
  };

  // --- intercept XHR (some apps use it) ---
  const OrigXHR = window.XMLHttpRequest;
  if (OrigXHR && OrigXHR.prototype && OrigXHR.prototype.open) {
    const origOpen = OrigXHR.prototype.open;
    const origSend = OrigXHR.prototype.send;
    OrigXHR.prototype.open = function (method, url) {
      this.__fgtUrl = url;
      return origOpen.apply(this, arguments);
    };
    OrigXHR.prototype.send = function () {
      const xhr = this;
      const url = xhr.__fgtUrl || "";
      const isCartAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      if (isCartAdd && window.__fgpAddingGifts !== true) {
        xhr.addEventListener("load", function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            try {
              const data = JSON.parse(xhr.responseText);
              const items = data.items || (Array.isArray(data) ? data : [data]);
              if (checkItems(items)) show();
            } catch (e) {}
          }
        });
      }
      return origSend.apply(this, arguments);
    };
  }
})();
